import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import React from 'react';

export const TableStyled = styled(Table)`
    [class='MuiTableCell-root'] {
        padding: 0.5rem;
    }
`;

export const TableContainerStyled = styled(TableContainer)<{
    component: React.ReactNode;
    clickable: boolean;
}>`
    position: relative;
    min-height: 500px;
    width: 100%;

    table {
        [class*='MuiTableCell-root'] {
            padding: 4px 10px;
            font-size: 13px;
        }
        [class*='MuiTableHead-root'] {
            //background-color: ${({ theme }) => theme.branding.gray.darker};
            //box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            th {
                //color: ${({ theme }) => theme.branding.text.light};
                //height: 2rem;
                line-height: 14px;
                font-size: 14px;
                padding: 4px 10px;
                background-color: #1ea7fd;
                font-weight: bold;
                color: white;
            }
        }
        [class*='MuiTableRow-root'] {
            &:hover {
                cursor: ${({ clickable }) =>
                    clickable ? 'pointer' : 'default'};
                background-color: ${({ clickable }) =>
                    clickable ? '#eceaf3' : '#fff'};
            }
        }
    }
`;

export const TableCellStyled = styled.div`
    overflow-wrap: anywhere;
`;
